// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2EGgT","footer":"ModalUpdate_footer__2-6Pt"};